/* Mirrors the theme's existing cart count; never writes a cart or payment. */
(() => {
  const bag = document.querySelector('[data-bot-quick-bag]');
  const bubble = document.getElementById('CartBubble');
  if (!bag || !bubble) return;
  const dock = document.querySelector('.bottom-nav');
  const place = () => {
    if (dock && innerWidth < 768) {
      const rect = dock.getBoundingClientRect();
      if (rect.height) bag.style.setProperty('--bot-bag-bottom', `${Math.max(78, innerHeight - rect.top + 8)}px`);
    } else bag.style.removeProperty('--bot-bag-bottom');
  };
  const sync = () => {
    const count = bubble.classList.contains('hidden') ? 0 : Number.parseInt(bubble.textContent, 10) || 0;
    bag.hidden = count < 1;
    bag.querySelector('[data-bot-bag-count]').textContent = String(count);
    bag.querySelector('.bot-quick-bag__view').setAttribute('aria-label', `View bag, ${count} ${count === 1 ? 'item' : 'items'}`);
  };
  new MutationObserver(sync).observe(bubble, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('pageshow', sync);
  window.addEventListener('resize', place);
  window.addEventListener('load', place, { once: true });
  if (dock) new ResizeObserver(place).observe(dock);
  document.addEventListener('product:added-to-cart', sync);
  sync();
  place();
})();
